import { Button } from "antd";
import { TableProps } from "antd/es/table";
import moment from "moment";
import { useAppSelector } from "../../../app/store";
import DownloadIcon from "../../../assets/icons/DownloadIcon";
import CustomTable from "../../../components/ui/CustomTable";
import { dateFormat } from "../../../constants/constants";
import { useGetReportListQuery } from "../../../features/report/reportApi";
import useError from "../../../hooks/useError";
import useTable from "../../../hooks/useTable";
import SidebarLayout from "../../../layouts/SidebarLayout";
import { formatDate } from "../../../lib/time";
import { GetReportQueryParams } from "../../../types/report";
import { capitalize } from "../../../utils/string";
import { addKeyInArray } from "../../../utils/utils";

// const { RangePicker } = DatePicker;

enum Status {
  pending = "status-warning",
  success = "status-success",
  failed = "status-danger",
}

export default function Report() {
  const { authInfo } = useAppSelector((state) => state.auth);
  const {
    // page,
    // limit,
    filter,
    // keyword,
    // handlePagination,
    // handleLimit,
    // // handleFilter,
    // handleSearch,
  } = useTable<GetReportQueryParams>();
  const reportParams: GetReportQueryParams = {
    ...filter,
    ...(authInfo?.business_id ? { business_id: authInfo.business_id } : {}),
    ...(authInfo?.role === "Manager" && authInfo?.id
      ? { manager_id: authInfo.id }
      : {}),
  };

  const { data, isLoading, isError, error } = useGetReportListQuery(
    {
      params: reportParams,
    },
    {
      skip: !authInfo?.business_id,
    }
  );
  useError(isError, error, "Get report list fail");

  const columns: TableProps<any>["columns"] = [
    {
      title: "#SL",
      align: "center",
      width: 60,
      render: (_, __, index) => index + 1,
      // render: (_, __, index) => countParPageSerialNumber(page, limit, index),
    },
    {
      title: <div className="text-nowrap w-[165px]">Request For</div>,
      dataIndex: "name",
      render: (val) => val || "-",
    },
    {
      title: "Report Range Date",
      render: (val) =>
        val?.startDate || val?.endDate ? (
          <span>
            {formatDate(val?.startDate, "DD/MM/YYYY")} to{" "}
            {formatDate(val?.endDate, "DD/MM/YYYY")}
          </span>
        ) : (
          "-"
        ),
    },
    {
      title: "Created at",
      dataIndex: "createdAt",
      render: (val) =>
        val ? moment(val).format(`${dateFormat} hh:mm A`) : "-",
    },
    {
      title: "Remark",
      dataIndex: "status",
      // align: "center",
      render: (val: keyof typeof Status, record) => (
        <div className="max-w-[200px]">
          {val === "failed" ? record?.remarks : "-"}
        </div>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      align: "center",
      render: (val: keyof typeof Status) => (
        <span className={`${Status[val]}`}>{capitalize(val)}</span>
      ),
    },

    {
      title: "Action",
      render: (val) => {
        return (
          <>
            {val?.status === "success" ? (
              <a download href={val?.fileUrl} target="_blank" rel="noreferrer">
                <Button
                  className="download-button !p-0 !h-fit !border-none !shadow-none"
                  size="small"
                  icon={<DownloadIcon />}
                  //  loading={isDownloading}
                  //  onClick={handleDownloadSalaryCertificate}
                >
                  Download
                </Button>
              </a>
            ) : (
              "-"
            )}
          </>
        );
      },
      align: "center",
    },
  ];

  return (
    <SidebarLayout title="Reports">
      <CustomTable
        loading={isLoading}
        columns={columns}
        dataSource={addKeyInArray(data)}
        // limit={limit}
        // page={page}
        // total={10}
        // handleLimit={handleLimit}
        // handlePagination={handlePagination}

        // filterSection={
        //   <>
        //     <Input
        //       suffix={<SearchIcon />}
        //       placeholder="Search"
        //       onChange={handleSearch}
        //     />
        //     <RangePicker
        //       format={dateFormat}
        //       style={{ width: 260 }}
        //       suffixIcon={<DateIcon />}
        //       // onChange={(e) => {
        //       //   handleFilter("start_date", e?.[0]?.format(dbDateFormat));
        //       //   handleFilter("end_date", e?.[1]?.format(dbDateFormat));
        //       // }}
        //     />
        //     <Select
        //       allowClear
        //       showSearch
        //       placeholder="All"
        //       filterOption={selectSearchOption}
        //       options={selectStringOption(Object.keys(Status), "string", true)}
        //       className="min-w-[120px]"
        //       suffixIcon={<SelectDownIcon />}
        //       rootClassName="icon-gray"
        //       // onChange={(e) => handleFilter("status", e)}
        //     />
        //   </>
        // }
      />
    </SidebarLayout>
  );
}

// const data: DataType[] = [
//   {
//     visitDate: "12 Dec, 2024",
//     visitTitle: "Visit title will go here",
//     note: "Note goes here",
//     status: "Created",
//     _id: "1",
//   },
//   {
//     visitDate: "12 Dec, 2024",
//     visitTitle: "Visit title will go here",
//     note: "Note goes here",
//     status: "Completed",
//     _id: "2",
//   },
//   {
//     visitDate: "12 Dec, 2024",
//     visitTitle: "Visit title will go here",
//     note: "Note goes here",
//     status: "Reached",
//     _id: "3",
//   },
// ];
